package tta.destinigo.talktoastro.feature_call_consultation.data.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class JoinQueueRequest(
    @SerialName("expert_id")val expertId:String,
    @SerialName("type")val consultationType:String
)
